import type {
  Action,
  SagaCallbacks,
} from '../types';

import * as actionTypes from './actionTypes';

export const requestDocuments = ({ userId }: { userId?: number } = {}): Action => ({
  type: actionTypes.REQUEST_DOCUMENTS,
  userId,
});

export const requestGetDocument = ({
  id,
  withAssignees,
  callbacks,
}: {
  id: number,
  withAssignees: boolean,
  callbacks?: SagaCallbacks,
}): Action => ({
  type: actionTypes.REQUEST_GET_DOCUMENT,
  id,
  withAssignees,
  callbacks,
});

export const requestAssignDocumentToClient = ({
  id,
  list,
  payload,
}: {
  id: number
  list?: string
  payload: any
}): Action => ({
  type: actionTypes.REQUEST_ASSIGN_DOCUMENT_TO_CLIENT,
  id,
  list,
  payload,
});

export const requestUnAssignDocumentToClient = ({
  id,
  clientId,
  assignmentId,
  callbacks,
}: {
  id: number
  clientId?: number
  assignmentId?: number
  callbacks?: SagaCallbacks
}): Action => ({
  type: actionTypes.REQUEST_UNASSIGN_DOCUMENT_TO_CLIENT,
  id,
  clientId,
  assignmentId,
  callbacks,
});

export const requestAssignDocumentToGroup = ({
  id,
  list,
  payload,
}: {
  id: number
  list?: string
  payload: any
}): Action => ({
  type: actionTypes.REQUEST_ASSIGN_DOCUMENT_TO_GROUP,
  id,
  list,
  payload,
});

export const requestUnAssignDocumentToGroup = ({
  id,
  qs,
}: {
  id: number
  qs: {
    document_id: number
  }
}): Action => ({
  type: actionTypes.REQUEST_UNASSIGN_DOCUMENT_TO_GROUP,
  id,
  qs,
});
